module.exports = __webpack_public_path__ + "img/rs_blackgreenT-logo.bfab6ca.png";